(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('lilyeve-birth-date')) {
    customElements.define('lilyeve-birth-date', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.controller?.abort();
        this.controller = new AbortController();
        this.input.addEventListener('beforeinput', () => {
          this.hadSelection = this.input.selectionStart !== this.input.selectionEnd;
        }, {signal: this.controller.signal});
        this.input.addEventListener('input', event => this.format(event), {signal: this.controller.signal});
        this.input.addEventListener('compositionend', () => this.format(), {signal: this.controller.signal});
        this.input.addEventListener('change', () => this.format(), {signal: this.controller.signal});
        this.format();
      }

      format(event) {
        if (event?.isComposing) return;
        const value = this.input.value;
        const cursor = this.input.selectionStart ?? value.length;
        let digits = value.replace(/\D/g, '').slice(0, 8);
        let digitCursor = value.slice(0, cursor).replace(/\D/g, '').length;
        const backward = event?.inputType === 'deleteContentBackward';
        const forward = event?.inputType === 'deleteContentForward';
        if ((backward || forward) && !this.hadSelection &&
            digits === this.lastDigits && value !== this.lastFormatted) {
          const index = backward ? digitCursor - 1 : digitCursor;
          if (index >= 0 && index < digits.length) {
            digits = digits.slice(0, index) + digits.slice(index + 1);
            if (backward) digitCursor--;
          }
        }
        const formatted = digits.slice(0, 2) +
          (digits.length >= 2 ? '/' + digits.slice(2, 4) : '') +
          (digits.length >= 4 ? '/' + digits.slice(4) : '');
        if (value !== formatted) {
          this.input.value = formatted;
          if (this.input.ownerDocument.activeElement === this.input) {
            const position = Math.min(formatted.length,
              digitCursor + (digitCursor >= 2 ? 1 : 0) + (digitCursor >= 4 ? 1 : 0));
            this.input.setSelectionRange(position, position);
          }
        }
        this.lastDigits = digits;
        this.lastFormatted = formatted;
        this.hadSelection = false;
        this.validate();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      validate() {
        const value = this.input.value;
        const parts = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value) || /^(\d{2})(\d{2})(\d{4})$/.exec(value);
        let message = '';
        if (value && !parts) {
          message = this.dataset.invalidMessage;
        } else if (parts) {
          const day = Number(parts[1]);
          const month = Number(parts[2]);
          const year = Number(parts[3]);
          const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
          const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
          const today = this.dataset.today.split('-').map(Number);
          const latest = (today[0] - 18) * 10000 + today[1] * 100 + today[2];
          if (year < 1900 || month < 1 || month > 12 || day < 1 || day > days[month - 1]) {
            message = this.dataset.invalidMessage;
          } else if (year * 10000 + month * 100 + day > latest) {
            message = this.dataset.ageMessage;
          }
        }
        this.input.setCustomValidity(message);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lilyeve-como-funciona"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', function (event) {
    if (!(event.target instanceof Element)) return;
    const item = event.target.closest('.lme-section__item');
    if (item) item.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lilyeve-main-product"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('lilyeve-buy')) {
  customElements.define('lilyeve-buy', class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready=true;
      this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
      this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);
      this.addEventListener('change',event=>{
        if(event.target.matches('[data-variant]')) this.update(true);
        if(event.target.matches('[data-plan]')) this.updatePrice();
      });
      this.addEventListener('click',event=>{
        const thumb=event.target.closest('[data-image]');
        if(thumb) this.showImage(thumb.dataset.image,thumb.dataset.alt);
      });
      this.update(false);
    }
    showImage(src,alt) {
      const photo=this.querySelector('.lybuy__photo');
      if(photo){photo.removeAttribute('srcset');photo.src=src;photo.alt=alt;}
      this.querySelectorAll('[data-image]').forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.image===src)));
    }
    update(changeUrl) {
      const selected=this.querySelector('[data-variant]').value;
      const variant=this.variants.find(v=>String(v.id)===selected);
      if(!variant) return;
      this.current=variant;
      const plan=this.querySelector('[data-plan]');
      if(plan){
        const previous=plan.value;
        plan.replaceChildren();
        if(!this.labels.requiresPlan) plan.add(new Option(this.labels.once,''));
        variant.plans.forEach(p=>plan.add(new Option(p.name+' — '+p.price,String(p.id))));
        if([...plan.options].some(o=>o.value===previous)) plan.value=previous;
      }
      const button=this.querySelector('[name="add"]');
      const canBuy=variant.available&&(!this.labels.requiresPlan||variant.plans.length>0);
      button.disabled=!canBuy;
      button.textContent=canBuy?this.labels.buy:this.labels.sold;
      const quantity=this.querySelector('[name="quantity"]');
      quantity.min=variant.min;quantity.step=variant.step;
      if(variant.max!==null)quantity.max=variant.max;else quantity.removeAttribute('max');
      quantity.value=variant.min;
      if(variant.image) this.showImage(variant.image,variant.alt);
      this.updatePrice();
      if(changeUrl){const url=new URL(location.href);url.searchParams.set('variant',selected);history.replaceState({},'',url);}
    }
    updatePrice() {
      const variant=this.current;
      const plan=this.querySelector('[data-plan]');
      const allocation=plan&&variant.plans.find(p=>String(p.id)===plan.value);
      this.querySelector('[data-price]').textContent=allocation?allocation.price:variant.price;
      const compare=this.querySelector('[data-compare]');
      compare.hidden=!!allocation||!variant.compare;
      compare.textContent=variant.compare||'';
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
